import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { AppService } from '../../app.service';
import { ContentService } from '../../services/content.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-results-blind-spots',
  templateUrl: './results-blind-spots.component.html',
  styleUrls: ['./results-blind-spots.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class ResultsBlindSpotsComponent implements OnInit {
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(
    private appService: AppService,
    private contentService: ContentService,
  ) {}

  ngOnInit() {
    let mbtiType = this.appService.mbtiType;

    this.contentService.getReport('TeamsIndividualBlindSpots', mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
